/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: DataOriginItem.tsx
 * Project: mle-client-n
 * Committed last: 2022/5/25 @ 1654
 * ---
 * Description:
 */

import {observer} from 'mobx-react';
import {Editor} from '../../store/observables/Editor';
import {DataOrigin} from '@revodigital/mle-dataresolver/lib/entities';
import {Button, Card, Intent, Tag} from '@blueprintjs/core';
import {useState} from 'react';
import {MyLabelOriginConfig} from '../editor/dialogs/data-origin/MyLabelOriginConfig';

interface Props {
  editor: Editor;
  dataOrigin: DataOrigin;
  onDelete: (dataOriginId: number) => any;
  disabled: boolean;
  onRefresh: (dataOriginId: number) => any;
  userName: string;
}

export const DataOriginItem = observer((props: Props) => {
  const [ editOpen, setEditOpen ] = useState(false);

  return (
    <Card className="flex flex-row p-2 my-2 place-content-between items-center">
      <div className="align-middle flex p-2 gap-x-1">
        { props.dataOrigin.name } <a href="http://beta.mylabel.it/it/recipes/"
                                     target="_blank">account { props.userName }</a>
        <Tag className="ml-2" minimal> Origine remota </Tag>
        <Tag minimal intent={ Intent.SUCCESS }
             className="ml-2">Connessa</Tag>
      </div>
      <div className="flex flex-row gap-x-3">
        <Button icon="edit" onClick={() => setEditOpen(true)}>Modifica
          revisione attiva</Button>
        <Button loading={props.disabled} icon="tick"
                onClick={() => props.onRefresh(props.dataOrigin.id)}>Verifica</Button>
      </div>
      {
        editOpen &&
        <MyLabelOriginConfig editor={ props.editor } isOpen={ editOpen }
                             onClose={ () => setEditOpen(false) }
                             showCloseButton/>
      }
    </Card>
  );
});
